import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-how',
  template: `
   <div class="mt-[60px] aspect43:flex aspect43:flex-wrap gap-[21px] place-content-center">
    <div class="h-[460px] aspect43:w-[586px] rounded-[26px] mb-4 aspect43:mb-0 bg-primary hover:bg-quintary p-5 aspect43:pt-[30px] aspect43:px-10 aspect43:pb-10">
        <div class="font-medium text-font60px leading-[60px] aspect43:text-[90px] text-white aspect43:leading-[90px]">COME<br>
        FUNZIONA</div>
        <div class="text-font26px leading-[30px] text-justify-disabled font-normal text-white mt-5">Il nostro processo è semplice, guidato e pensato per farti risparmiare tempo. Segui pochi passaggi per accedere ai bandi giusti, ricevere supporto e portare avanti il tuo progetto</div>
    </div>
    <div class="aspect43:w-[calc(100%-607px)] flex place-content-between flex-wrap gap-y-[16px] leading-[var(--30px)]">
        <div (click)="goTo('login')"
            class="bg-primary hover:bg-quintary cursor-pointer w-[calc(50%-5px)] aspect43:w-[calc(50%-10px)] h-[222px] px-[25px] rounded-[26px] relative overflow-hidden">
            <div
                class="h-full py-5 flex items-end text-white text-font14px aspect43:text-font40px leading-[20px] aspect43:leading-[40px]">
                Registrati e crea il tuo profilo
            </div>
            <div
                class="text-[280px] aspect43:text-[300px] font-semibold text-quaternary opacity-10 absolute top-[160px] left-[11px] font-kansas">
                1</div>
        </div>
        <div (click)="goTo('cerca-bando')"
            class="bg-primary hover:bg-quintary cursor-pointer w-[calc(50%-5px)] aspect43:w-[calc(50%-10px)] h-[222px] px-[25px] rounded-[26px] relative overflow-hidden">
            <div
                class="h-full py-5 flex items-end text-white text-font14px aspect43:text-font40px leading-[20px] aspect43:leading-[40px]">
                <div>Visualizza i bandi</div>
            </div>
            <div
                class="text-[280px] aspect43:text-[300px] font-semibold text-quaternary opacity-10 absolute top-[160px] left-[11px] font-kansas">
                2</div>
        </div>
        <div (click)="goTo('login')"
            class="bg-primary hover:bg-quintary cursor-pointer w-[calc(50%-5px)] aspect43:w-[calc(50%-10px)] h-[222px] px-[25px] rounded-[26px] relative overflow-hidden">
            <div
                class="h-full py-5 flex items-end text-white text-font14px aspect43:text-font40px leading-[20px] aspect43:leading-[40px]">
                Ricevi notifiche sui nuovi bandi
            </div>
            <div
                class="text-[280px] aspect43:text-[300px] font-semibold text-quaternary opacity-10 absolute top-[160px] left-[11px] font-kansas">
                3</div>
        </div>
        <div (click)="goTo('piani')"
            class="bg-primary hover:bg-quintary cursor-pointer w-[calc(50%-5px)] aspect43:w-[calc(50%-10px)] h-[222px] px-[25px] rounded-[26px] relative overflow-hidden">
            <div
                class="h-full py-5 flex items-end text-white text-font14px aspect43:text-font40px leading-[20px] aspect43:leading-[40px]">
                Scegli un piano di abbonamento per
attivare le funzionalità a te riservate
            </div>
            <div
                class="text-[280px] aspect43:text-[300px] font-semibold text-quaternary opacity-10 absolute top-[160px] left-[11px] font-kansas">
                4</div>
        </div>
    </div>
</div>
  `,
  styles: [],
  standalone: false,
})
export class HowComponent {

    goTo(route:string){
    // this.router.navigate(['piani'])
    window.location.replace(route)
  }
}
